// stores/ContactStore.ts
import { makeAutoObservable, observable } from "mobx";
import api, {
  PostContactParameters,
  PostContactRes,
} from "../api";
import { createRequestStatus, handleRequest, handleLoadMoreRequest } from "../toll/toolRequestStatus";

class ContactStore {
  createContactStatus = createRequestStatus();
  createContactSuccess?: boolean
  createContactData?: PostContactRes


  constructor () {
    makeAutoObservable(this);
  }

  resetCreateContact() {
    this.createContactSuccess = false;
    this.createContactData = undefined
  }


  createContact = async (params: PostContactParameters) => {
    await handleRequest<PostContactRes>(
      this.createContactStatus,
      () => api.PostContact(params),
      (res) => {
        this.createContactData = res
        this.createContactSuccess = true;
      },
      "新增捐款失败"
    );
  };

}


export default new ContactStore();;
